import { ref, computed } from 'vue'
import debounce from 'lodash.debounce'

/**
 * Composable для определения типа устройства и viewport
 * Используется для условного рендеринга mobile/desktop компонентов
 *
 * Breakpoints:
 * - mobile: < 768px
 * - tablet: 768px - 1023px
 * - desktop: >= 1024px
 */

const BREAKPOINTS = {
    mobile: 768,
    tablet: 1024
}

// Shared state — один слушатель на все компоненты
const viewportWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024)
const isTouchDevice = ref(false)

function updateWidth() {
    if (typeof window !== 'undefined') {
        viewportWidth.value = window.innerWidth
    }
}

function detectTouch() {
    if (typeof window !== 'undefined') {
        isTouchDevice.value = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    }
}

// Initialize once on module load
if (typeof window !== 'undefined') {
    detectTouch()
    updateWidth()

    const debouncedUpdate = debounce(updateWidth, 100)
    window.addEventListener('resize', debouncedUpdate)
}

const isMobile = computed(() => viewportWidth.value < BREAKPOINTS.mobile)
const isTablet = computed(() => viewportWidth.value >= BREAKPOINTS.mobile && viewportWidth.value < BREAKPOINTS.tablet)
const isDesktop = computed(() => viewportWidth.value >= BREAKPOINTS.tablet)
const isTouch = computed(() => isTouchDevice.value)

export function useMobile() {
    return {
        viewportWidth,
        isMobile,
        isTablet,
        isDesktop,
        isTouch,
        // aliases for shorter templates
        mobile: isMobile,
        tablet: isTablet,
        desktop: isDesktop,
        touch: isTouch
    }
}
